import styles from "./resident-status-toggle.module.css";
import { inject, observer } from "mobx-react";
import { ClientOverviewStore } from "../../store/store";
import ToggleButtonsComponent from "../../../../components/toggle-button/ToggleButtonGroup";
import { ReactComponent as ArrowUp } from "../../svg/arrow-up.svg";
import { ReactComponent as ArrowDown } from "../../svg/arrow-down.svg";
import { useTranslation } from "react-i18next";
import UserSettingsStore, {
    SortSettings,
    UserSettings,
} from "../../../../store/user-settings";

export interface ResidentStatusToggleProps {
    clientOverviewStore?: ClientOverviewStore;
    userSettingsStore?: UserSettingsStore;
}

function ResidentStatusToggle(props: ResidentStatusToggleProps) {
    const clientOverviewStore = props.clientOverviewStore!;
    const userSettingsStore = props.userSettingsStore!;
    const sortOptions = userSettingsStore.getUserSetting(
        SortSettings.RESIDENT_STATUS
    )!;
    const { t } = useTranslation("client-grid");
    const privacyMode = userSettingsStore.getUserSetting(
        UserSettings.PRIVACY_MODE
    );

    const getIcon = (id: string) => {
        if (sortOptions.id === id) {
            if (sortOptions.desc) {
                return <ArrowDown />;
            } else {
                return <ArrowUp />;
            }
        }

        return (
            <div className={styles["inactive"]}>
                <ArrowUp /> <ArrowDown />
            </div>
        );
    };

    const buttons = [
        {
            id: "name",
            icon: getIcon("name"),
            text: t("Client"),
        },
        { id: "room", icon: getIcon("room"), text: t("Room") },
        { id: "status", icon: getIcon("status"), text: t("Status") },
    ];

    if (privacyMode) {
        buttons.splice(0, 1);
    }

    const render = () => {
        return (
            <ToggleButtonsComponent
                buttons={buttons}
                selectedID={sortOptions.id}
                onChange={(ID: string) => {
                    if (ID === null) {
                        userSettingsStore.setSortSetting(
                            SortSettings.RESIDENT_STATUS,
                            {
                                id: sortOptions.id,
                                desc: !sortOptions.desc,
                            }
                        );
                    } else {
                        userSettingsStore.setSortSetting(
                            SortSettings.RESIDENT_STATUS,
                            {
                                id: ID,
                                desc: false,
                            }
                        );
                    }
                }}
            />
        );
    };

    return render();
}

export default inject(
    "clientOverviewStore",
    "userSettingsStore"
)(observer(ResidentStatusToggle));
